import { Component, input, output, OnInit, ChangeDetectionStrategy, effect } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { ReportInfo, ReportRecord } from '../../models/report.model';
import { groupByProperty } from '../../shared/utils/group-by-property';
import { EditableFieldsService } from '../editable-fields.service';
import { digger } from '@cbre/digger';
import { LocaleId } from '../../models/locale.model';
import { contactsSectionRequiredCountries } from '../../shared/constants/template.const';
import { ActionsToolbarComponent } from './actions-toolbar/actions-toolbar.component';

import { DynamicContactsComponent } from '../presentation-dynamic-view/dynamic-contacts/dynamic-contacts.component';
import { RecordBodyComponent } from './record-body/record-body.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-presentation-view',
  templateUrl: './presentation-view.component.html',
  styleUrl: './presentation-view.component.scss',
  providers: [EditableFieldsService],
  imports: [ActionsToolbarComponent, DynamicContactsComponent, RecordBodyComponent],
})
export class PresentationViewComponent extends AbstractDynamicReportViewComponent implements OnInit {
  recordNumber: number;
  recordsCount: number;
  reportRecordsData: ReportInfo;
  isContactsVisible = false;

  readonly fullLoaded = input<boolean>(false);
  readonly removeRecord = output<ReportRecord>();
  readonly reportReordered = output<ReportRecord[]>();

  constructor() {
    super();
    effect(() => {
      const reportData = this.reportData();
      const currentView = this.currentView();
      const reportLocale = this.reportLocale();
      const fullLoaded = this.fullLoaded();
      if (
        !!reportData &&
        reportData.records &&
        !!currentView &&
        reportData.entity === 'availability' &&
        [15, 3, 4, 43, 44].includes(currentView.templateId)
      ) {
        const groupRecordsByEntity = groupByProperty(reportData.records) as ReportRecord[];
        this.recordsCount = !!reportData && !!groupRecordsByEntity ? groupRecordsByEntity.length : null;
        this.reportRecordsData = { ...reportData, records: groupRecordsByEntity };
      } else if (!!currentView) {
        this.recordsCount = !!reportData && !!reportData.records ? reportData.records.length : null;
        this.reportRecordsData = reportData;
      }
      if (reportLocale === LocaleId.IndiaEnglish && fullLoaded) {
        this.getStackingPlanSLide();
      }
      this.isContactsVisible =
        reportLocale &&
        currentView?.templateId === 41 &&
        contactsSectionRequiredCountries.includes(reportLocale);
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }

  navRecordNum(recordNumber: number) {
    this.recordNumber = recordNumber;
  }

  private getStackingPlanSLide() {
    const reportData = this.reportData();
    const payload = reportData.records.map(item => {
      return {
        availability_id: item.edpRecordId,
        property_id: digger(item.data, 'property.id'),
        floor: Math.floor(digger(item.data, 'floor_suite.floor_number')),
      };
    });
    this.reportExportViewService.getStackingPlan(payload);
  }
}
